export default {
    namespaced: true,
    state: {
        system: '',
        token: '',
        userInfo: null
    },
    mutations: {
        // 设置分页大小
        SET_SYSTEM(state, data) {
            state.system = data;
        },
        // 设置token
        SET_TOKEN(state, data) {
            state.token = data;
        },
        SET_USERINFO(state, data) {
            state.userInfo = data;
        }
    },
    actions: {
        // 设置分页大小
        setSystem({commit}, data) {
            commit('SET_SYSTEM', data)
        },
        // 设置token
        setToken({commit}, data) {
            commit('SET_TOKEN', data)
        },
        setUserInfo({commit}, data) {
            commit('SET_USERINFO', data)
        }
    }
}